<template>
  <div class="card">
    <div class="card-header header-elements-inline border-bottom mb-3">
      <h5 class="card-title text-uppercase">
        {{ $t('_ReportTotalSales.Total Sales') }}
      </h5>
      <div
        v-if="staff && staff.id != 'ALL'"
        class="header-elements"
      >
        <div class="list-icons">
          <img
            class="fix-logosize image_box mr-2 rounded-circle"
            :src="staff.image_url"
            v-if="staff.image_url"
          >
          <span>{{ staff.text }}</span>
        </div>
      </div>
    </div>
    
    <div class="card-body">
      <div class="chart-container">
        <v-chart
          v-if="isShow"
          class="chart"
          :option="option"
          autoresize
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
    use
} from "echarts/core";
import {
    CanvasRenderer
} from "echarts/renderers";
import {
    LineChart
} from "echarts/charts";
import {
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    GridComponent,
    ToolboxComponent,
} from "echarts/components";
import VChart, {
    THEME_KEY
} from "@/plugins/vue-echarts";
use([
    CanvasRenderer,
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    GridComponent,
    ToolboxComponent,
    LineChart,
]);

export default {
    props: {
        indicatorCustomerOptions:{
            type: Object,
            default: () => ({}),
        }, 
        staff:{
            type: Object,
            default: () => ({}),
        }
    },
    components: {
        VChart,
    },
    provide: {
        [THEME_KEY]: "default",
    },
    data() {
        return {
            isShow: true,
            option: {
                textStyle: {
                    fontFamily: 'Sarabun',
                },
                color: ["#1565C0", "#04A9F4", "#FFA726"],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "cross",
                        label: {
                            backgroundColor: "#1565C0",
                        },
                    },
                },
                legend: {
                    left: "center",
                },
                grid: {
                    left: "15",
                    right: "15",
                    top: "30",
                    bottom: "0",
                    containLabel: true,
                },
                xAxis: [
                    {
                        type: "category",
                        boundaryGap: false,
                        data: this.$parent.reportData.chart.series,
                    }
                ],
                yAxis:[
                    {
                        name: this.$t("Sales"),
                        nameTextStyle: {
                            align: "left",
                        },
                        alignTicks: true,
                        type: "value",
                        axisLabel: {
                            formatter: function (value) {
                                if (value > 1000000) {
                                    var n = value / 1000000;
                                    return n + "M";
                                }
                                if (value > 999) {
                                    var n = value / 1000;
                                    return n + "K";

                                } else {
                                    return value;
                                }
                            },
                        },
                         offset: 15
                    },
                    {
                        name: this.$t('Number Order'),
                        nameTextStyle: {
                            align: "right",
                        },
                        type: "value",
                        axisLabel: {
                            margin: 40,
                            formatter: function (value) {
                                return value;
                            },
                        },
                    },
                ],
                series: [
                    {
                        name: this.$t('Sales'),
                        type: "line",
                        smooth: true,
                        symbol: "squareRatio",
                        lineStyle: {
                            width: 2.3,
                            color: "#1565C0",
                        },
                        areaStyle: {
                            opacity: 0.8,
                            color: "rgba(116, 89, 217, 0.1)",
                        },
                        data: this.$parent.reportData.chart.sales,
                    },
                    {
                        name: this.$t('Number Order'),
                        type: "bar",
                        barMaxWidth: 20,
                        barWidth: "80%",
                        barGap: "10%",
                        itemStyle: {
                            color: '#04A9F4',
                        },
                        yAxisIndex: 1,
                        data: this.$parent.reportData.chart.orders,
                    },
                ],
            },
            isLoaded: false,
        };
    },
    mounted() {
    },
    computed: {

    },
    watch: {
        indicatorCustomerOptions(newValue) {
            this.isShow = false;
            if(newValue != '') {
                this.option.series.push(newValue);
            } else {
                this.option.series.pop();
            }
            this.$nextTick(function() {
                this.isShow = true
            })
        }
    }
};
</script>

<style scoped>
.chart {
    height: 380px;
}
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/report/SalesOrder/SalesChart.vue